import axios from 'axios';
import AppSettings from "../../../core/AppSettings";

export const getCartPotentialPointsEspot = () => {
    const potentialCartPointsEspotURL = "/wcs/resources/store/" + AppSettings.storeId + "/espot/Cart_Potential_Points?noCache=true";

    return axios.get(potentialCartPointsEspotURL).then((response) => { return response; }, (error) => { return error; });
};
